import PhoneSettings from './PhoneSettings';

export default PhoneSettings;
